import React, {Fragment, useState} from 'react';
import {QUERY_FORM_FILTER_MODE_PLAIN, QUERY_FORM_FILTER_MODE_TREE} from "../../query-form";
import {Button, Card, Col, Input, Modal, Radio, Row} from "antd";
import {GUTTER_SM, MARGIN_MD, MODAL_WIDTH_LG} from "../../../styles/constants";
import FilterForm from "../../filter-form";
import TreeFilter from "../../tree-filter";
import {translate} from 'react-i18next';
import {getArtefactTripletFromUrn} from "../../../utils/sdmxJson";
import {
  addELFilterModeSimpleBlock,
  addELFilterModeSimpleCondition,
  changeELFilterMode,
  changeELFilterModeAdvancedMode,
  changeELFilterModeAdvancedValues,
  changeELFilterModeSimpleValues,
  deleteELFilterModeSimpleBlock,
  deleteELFilterModeSimpleCondition,
  readELCodelistCount,
  readELCodelistItems,
  readELCsvCountAndItems,
  readELCsvHeader,
  readELFilterModeSimpleValues,
  readELSrcDataflowDsd,
  resetELFilter,
  resetELFilterModeSimpleValues
} from "../actions";
import {connect} from "react-redux";
import {compose} from "redux";
import Call from "../../../hocs/call";
import EnhancedModal from "../../enhanced-modal";
import {EL_SOURCE_FORMAT_SDMX_EP, EL_STEP_FILTER} from "../constants";

const mapStateToProps = state => ({
  step: state.scenes.easyLoading.step,
  sourceFormat: state.scenes.easyLoading.sourceFormat,
  connectionEndpointId: state.scenes.easyLoading.connectionEndpointId,
  srcDataflow: state.scenes.easyLoading.srcDataflow,
  srcFile: state.scenes.easyLoading.srcFile,
  dsdColumns: state.scenes.easyLoading.dsdColumns,
  filterMode: state.scenes.easyLoading.filterMode,
  filter: state.scenes.easyLoading.filter,
  treeFilter: state.scenes.easyLoading.treeFilter,
  filterStr: state.scenes.easyLoading.filterStr,
});

const mapDispatchToProps = dispatch => ({
  fetchDataflowDsd: ({dsdTriplet, endpointId}) => dispatch(readELSrcDataflowDsd(dsdTriplet, endpointId)),
  fetchCodelistCount: (sdcDataflowTriplet, dimensionId, endpointId) =>
    dispatch(readELCodelistCount(sdcDataflowTriplet, dimensionId, endpointId)),
  fetchCodelistItems: (sdcDataflowTriplet, dimensionId, endpointId) =>
    dispatch(readELCodelistItems(sdcDataflowTriplet, dimensionId, endpointId)),
  fetchCsvHeader: ({separator, delimiter, hasHeader, csvPath}) =>
    dispatch(readELCsvHeader(separator, delimiter, hasHeader, csvPath)),
  fetchCsvCountAndItems: ({dimensionId, separator, delimiter, hasHeader, csvPath}) =>
    dispatch(readELCsvCountAndItems(dimensionId, separator, delimiter, hasHeader, csvPath)),
  onFilterModeChange: mode => dispatch(changeELFilterMode(mode)),
  onModeAdvancedValuesChange: (colName, values) => dispatch(changeELFilterModeAdvancedValues(colName, values)),
  onModeAdvancedModeChange: (colName, mode) => dispatch(changeELFilterModeAdvancedMode(colName, mode)),
  onModeSimpleBlockAdd: () => dispatch(addELFilterModeSimpleBlock()),
  onModeSimpleBlockDelete: blockIndex => dispatch(deleteELFilterModeSimpleBlock(blockIndex)),
  onModeSimpleConditionAdd: blockIndex => dispatch(addELFilterModeSimpleCondition(blockIndex)),
  onModeSimpleConditionDelete: (blockIndex, conditionIndex) => dispatch(deleteELFilterModeSimpleCondition(blockIndex, conditionIndex)),
  onModeSimpleValuesChange: fields => dispatch(changeELFilterModeSimpleValues(fields)),
  fetchModeSimpleValues: (dimensionId, separator, delimiter, hasHeader, csvPath) =>
    dispatch(readELFilterModeSimpleValues(dimensionId, separator, delimiter, hasHeader, csvPath)),
  onModeSimpleValuesReset: dimensionId => dispatch(resetELFilterModeSimpleValues(dimensionId)),
  onFilterReset: () => dispatch(resetELFilter())
});

const ELFilterStep = ({
                        t,
                        step,
                        sourceFormat,
                        connectionEndpointId,
                        srcDataflow,
                        srcFile,
                        dsdColumns,
                        filterMode,
                        filter,
                        treeFilter,
                        filterStr,

                        sdmxFilters,
                        disabled = false,

                        fetchDataflowDsd,
                        fetchCsvHeader,

                        onFilterReset,

                        onFilterModeChange,

                        onModeSimpleBlockAdd,
                        onModeSimpleBlockDelete,
                        onModeSimpleConditionAdd,
                        onModeSimpleConditionDelete,
                        onModeSimpleValuesChange,
                        fetchModeSimpleValues,
                        onModeSimpleValuesReset,

                        fetchCodelistCount,
                        fetchCodelistItems,
                        fetchCsvCountAndItems,
                        onModeAdvancedValuesChange,
                        onModeAdvancedModeChange
                      }) => {

  const [isFilterQueryModalVisible, setFilterQueryModalVisibility] = useState(false);

  const columns = (dsdColumns || []).length > 0
    ? dsdColumns.map(col => ({
      ...col,
      fetchValues: () => fetchModeSimpleValues(col.id, srcFile.separator, (srcFile.delimiter || null), true, srcFile.csvPath),
      resetValues: () => onModeSimpleValuesReset(col.id)
    }))
    : null;

  return (
    <Call
      cb={fetchDataflowDsd}
      cbParam={{
        dsdTriplet: srcDataflow ? getArtefactTripletFromUrn(srcDataflow.structure) : null,
        endpointId: connectionEndpointId
      }}
      disabled={sourceFormat !== EL_SOURCE_FORMAT_SDMX_EP || step !== EL_STEP_FILTER || !srcDataflow || columns}
    >
      <Call
        cb={fetchCsvHeader}
        cbParam={{
          separator: srcFile ? srcFile.separator : null,
          delimiter: (srcFile && srcFile.delimiter) ? srcFile.delimiter : null,
          hasHeader: true,
          csvPath: srcFile ? srcFile.csvPath : null
        }}
        disabled={sourceFormat === EL_SOURCE_FORMAT_SDMX_EP || step !== EL_STEP_FILTER || !srcFile || columns}
      >
        {columns && (
          <Fragment>
            <Row type="flex" justify="space-between" style={{marginBottom: MARGIN_MD}}>
              <Col>
                {!sdmxFilters && (
                  <Radio.Group
                    disabled={disabled}
                    value={filterMode}
                    onChange={({target}) => {
                      if (filterStr.length > 0) {
                        Modal.confirm({
                          title: t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.confirms.filterModeChange.title'),
                          content: t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.confirms.filterModeChange.content'),
                          onOk() {
                            onFilterModeChange(target.value);
                          },
                          cancelText: t('commons.buttons.cancel.title')
                        })
                      } else {
                        onFilterModeChange(target.value)
                      }
                    }}
                  >
                    <Radio.Button value={QUERY_FORM_FILTER_MODE_PLAIN}>
                      {t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.buttons.filterModeRadio.plain.title')}
                    </Radio.Button>
                    <Radio.Button value={QUERY_FORM_FILTER_MODE_TREE}>
                      {t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.buttons.filterModeRadio.tree.title')}
                    </Radio.Button>
                  </Radio.Group>
                )}
              </Col>
              <Col>
                <Row type="flex" gutter={GUTTER_SM}>
                  <Col>
                    <Button
                      icon="code"
                      onClick={() => setFilterQueryModalVisibility(true)}
                      disabled={filterStr.length === 0}
                    >
                      {t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.buttons.showQuery.title')}
                    </Button>
                  </Col>
                  <Col>
                    <Button
                      icon="delete"
                      onClick={onFilterReset}
                      disabled={disabled}
                    >
                      {t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.buttons.resetFilter.title')}
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
            {filterMode === QUERY_FORM_FILTER_MODE_PLAIN && (
              <Card bodyStyle={{height: 396, overflow: "auto"}}>
                <FilterForm
                  disabled={disabled}
                  columns={columns}
                  filter={filter}
                  onChange={onModeSimpleValuesChange}
                  onBlockAdd={onModeSimpleBlockAdd}
                  onBlockDelete={onModeSimpleBlockDelete}
                  onBlockConditionAdd={onModeSimpleConditionAdd}
                  onBlockConditionDelete={onModeSimpleConditionDelete}
                />
              </Card>
            )}
            {filterMode === QUERY_FORM_FILTER_MODE_TREE && (
              <div className="query__tree-filter">
                <TreeFilter
                  disabled={disabled}
                  columns={columns}
                  treeFilter={treeFilter}
                  fetchColumnCodelistCount={({dimensionId}) => sourceFormat === EL_SOURCE_FORMAT_SDMX_EP
                    ? fetchCodelistCount(srcDataflow, dimensionId, connectionEndpointId)
                    : fetchCsvCountAndItems({
                      dimensionId: dimensionId,
                      separator: srcFile ? srcFile.separator : null,
                      delimiter: (srcFile && srcFile.delimiter) ? srcFile.delimiter : null,
                      hasHeader: true,
                      csvPath: srcFile ? srcFile.csvPath : null
                    })
                  }
                  fetchColumnCodelistTree={({dimensionId}) => sourceFormat === EL_SOURCE_FORMAT_SDMX_EP
                    ? fetchCodelistItems(srcDataflow, dimensionId, connectionEndpointId)
                    : null
                  }
                  fetchColumnFilteredValues={null}
                  onColumnModeChange={onModeAdvancedModeChange}
                  onColumnValuesChange={onModeAdvancedValuesChange}
                  hideInclusionRadio={sdmxFilters}
                  isSdmx={sdmxFilters}
                  isCC
                  hideIds={sourceFormat !== EL_SOURCE_FORMAT_SDMX_EP}
                  showTimePeriodAsTree={sourceFormat !== EL_SOURCE_FORMAT_SDMX_EP}
                />
              </div>
            )}
            <EnhancedModal
              visible={isFilterQueryModalVisible}
              onCancel={() => setFilterQueryModalVisibility(false)}
              footer={
                <Button onClick={() => setFilterQueryModalVisibility(false)}>
                  {t('commons.buttons.close.title')}
                </Button>
              }
              width={MODAL_WIDTH_LG}
              title={t('scenes.dataManager.dataflowBuilder.wizard.query.whereConditions.filterQueryModal.title')}
            >
              <div style={{fontFamily: 'monospace'}}>
                <Input.TextArea
                  disabled
                  value={filterStr}
                  style={{
                    overflow: 'auto',
                    resize: 'none',
                    height: 560
                  }}
                />
              </div>
            </EnhancedModal>
          </Fragment>
        )}
      </Call>
    </Call>
  )
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  translate()
)(ELFilterStep);


// WEBPACK FOOTER //
// ./src/components/easy-loading/filter-step/index.jsx